import script from "./BlogSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogSearch.vue?vue&type=script&setup=true&lang=ts"

import "./BlogSearch.vue?vue&type=style&index=0&id=05fd53fb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05fd53fb"]])

export default __exports__